import { useState } from "react";
import { supabase } from "../supabase"; 
import { Loader2 } from "lucide-react";
import "./Login.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
  
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  
    if (error) {
      console.error("Login failed:", error.message);
      setError(error.message);
    } else if (data?.user) {
      console.log("Login successful:", data.user);
      window.location.href = "/conversations"; 

    }
  
    setLoading(false);
  };
  

  return (
    <div className="LoginContainer">
      <div className="LoginGlassCard">
        <h2 className="LoginTitle">Welcome Back</h2>
        <p className="LoginSubtitle">Sign in to your account</p>

        {error && <p className="LoginError">{error}</p>}

        <form onSubmit={handleLogin} className="LoginForm">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="LoginInput"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="LoginInput"
            required
          />
          <button type="submit" className="LoginButton" disabled={loading}>
            {loading ? <Loader2 className="LoginLoader" /> : "Sign In"}
          </button>
        </form>

        {/* <p className="LoginFooterText">
          Don't have an account? <a href="/signup" className="LoginLink">Sign Up</a>
        </p> */}
      </div>

      <div className="LoginBubbles">
        {[...Array(10)].map((_, i) => (
          <span key={i} className="LoginBubble"></span>
        ))}
      </div>
    </div>
  );
};

export default LoginPage;
